import { RiShareLine } from 'react-icons/ri';
import Shared_Home from 'pages/Home';
import StudyWithTeacher from 'modules/StudyWithTeacher';

export default [
  {
    path: '/home',
    name: 'Trang chủ',
    miniName: 'T',
    component: Shared_Home,
    icon: 'fas fa-home text-info',
    layout: '/lms',
    exact: true,
    roles: ['authenticated'],
    showInSidebar: true,
    sortOrder: 0,
  },
  {
    path: '/study-with-teacher',
    name: 'Học cùng giáo viên bản ngữ',
    miniName: 'lwt',
    component: StudyWithTeacher,
    icon: <RiShareLine className='text-red' size={20} />,
    layout: '/lms',
    exact: true,
    roles: ['authenticated'],
    showInSidebar: true,
    sortOrder: 999,
  },
];
